import { ModelTransformer } from '../../common/common.model';
import {
    ExtMetricDataItem,
    PerformanceDataViewType,
} from '../../performance-data/metric.pd.model';
import { PerformanceMetricData } from '../models/performance-metric-data.model';

/**
 * Transforms an ExtMetricDataItem into a PerformanceMetricData object.
 */
export class MetricModelTransformer
    implements ModelTransformer<PerformanceMetricData, ExtMetricDataItem>
{
    private readonly viewType: PerformanceDataViewType;

    constructor(viewType: PerformanceDataViewType) {
        this.viewType = viewType;
    }

    /**
     * Transforms a single ExtMetricDataItem into PerformanceMetricData.
     * @param metric A single ExtMetricDataItem.
     * @returns A transformed PerformanceMetricData object.
     */
    transform(metric: ExtMetricDataItem): PerformanceMetricData {
        return {
            userId: metric.primaryId,
            userName: metric.primaryName,
            metricID: metric.metricID,
            metricName: metric.metricName,
            actual: metric.actual,
            goal: metric?.goal,
            previousActual: metric.previousActual,
            target: metric.target,
            eventDate: new Date(metric.eventDate),
            secondaryName: metric.secondaryName,
            targetThresholdColour: metric.targetThresholdColour,
            viewType: this.viewType,
        };
    }

    /**
     * Transforms an array of ExtMetricDataItem objects into an array of PerformanceMetricData objects.
     * @param metrics An array of ExtMetricDataItem objects.
     * @returns An array of transformed PerformanceMetricData objects.
     */
    transformList(metrics: ExtMetricDataItem[]): PerformanceMetricData[] {
        return metrics.map((metric) => this.transform(metric));
    }
}
